<app-styled-banner [banner]="banner"></app-styled-banner>
<app-album-gallery [albumsBasic]="albums" [albumsFull]="albumsFinal" [error]="error" [showDetailsId]="showDetailsId">
</app-album-gallery>
